import useStyles from "../../../assets/styles/styles";
import { Typography } from "@material-ui/core";

import NotFound from "../../HomeLogged/NotFound";
import { useResizeScreen } from "../../../hooks/useResizeScreen";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { cleanPerfilCompleto, getPerfilCompleto } from "../../../redux/actions/medicalRecords";
import ModalProfile from "../../DialogProfile/Modal";
import { formatRawPhoneNumber } from "../../../utils/utilsFunctions";
import MedicalCard from "../Card/MedicalCard";
import MedicalCardExternal from "../Card/MedicalCardExternal";
import CircularProgress from '@mui/material/CircularProgress';
import NotFoundExternal from "../../HomeLogged/NotFoundExternal";


const MedicalRecordContainer = ({ showMapsExternal, mapsExternal, filteredData, noResults  }) => {
    const classes = useStyles();
    const { screen } = useResizeScreen();
    const dispatch = useDispatch();
    const {loading, cartilla, completeProfile} = useSelector((state) => state.cartillaReducer);
    const [profileSelected, setProfileSelected] = useState(undefined);
    const [open, setOpen] = useState(false);

    const handleClick = (item, i) => (e) => {
        dispatch(getPerfilCompleto({ PrestadorNumero: item.prestadorNumero }));
        setOpen(true);
    };

    function cardStyles() {
        let response = `${classes.newsRoot} ${classes.addListCardWeb}`;
        if (screen.sWidth <= '800') {
            response = `${classes.imageListCard} ${classes.addListCardMobile}`;
        }
        return response;
    }

    function validFilter(isOpen) {
        return isOpen ? "blur(2px)" : " blur(0px)";
    }

    useEffect(() => {
        setProfileSelected(completeProfile);
    }, [completeProfile]);

    useEffect(() => {
        !open && setProfileSelected(undefined);
    },[open]);

    useEffect(() => {
        return (() => {
            dispatch(cleanPerfilCompleto());
        });
    }, []);

    return (
        <>
            {!mapsExternal &&
                (loading ? (
                    <section className={`${classes.newsRoot} ${classes.addListCardLoading}`}>
                        <CircularProgress />
                    </section>
                ) : filteredData?.length > 0 ? (
                    <section>
                        <div
                            className={`${cardStyles()} ${classes.imageListChildren}`}
                            style={{
                                filter: validFilter(open),
                                gap: '0px',
                                display: 'grid',
                                justifyItems: "center"
                            }}
                        >
                            {filteredData?.map((item, i) => (<>
                                <MedicalCardExternal item={item} i={i} handleClick={handleClick} showMapsExternal={showMapsExternal} filteredData={filteredData} />
                            </>
                            ))}
                        </div>
                    </section>
                ) : (
                    <>
                        {noResults && (
                            <NotFoundExternal
                                wsItem={filteredData}
                                fullItem={filteredData}
                                loading={loading}
                            />
                        )}

                        <NotFoundExternal
                            wsItem={cartilla?.cartilla}
                            fullItem={cartilla}
                            loading={loading}
                        />
                    </>
                )
                )}
            {open && (
                profileSelected ?
                    (<ModalProfile
                        title={
                            <>
                                <Typography className={classes.titleDialogTitle}>
                                    {completeProfile?.prestador?.prestadorRazonSocial}
                                </Typography>
                                <Typography className={classes.subTitleDialogTitle}>
                                    {completeProfile?.prestador?.especialidad[0]?.especialidadDescripcion}
                                </Typography>
                            </>
                        }
                        description={
                            <>
                                <Typography paragraph className={classes.subParagraphDialog}>
                                    DATOS DEL PRESTADOR {completeProfile?.prestador?.prestadorRazonSocial}
                                </Typography>
                                <Typography className={classes.titleDialogContent}>
                                    TELEFONO:
                                </Typography>
                                { completeProfile?.prestador?.telefono?.length > 0 ?
                                    completeProfile?.prestador?.telefono?.map((phone, i) => (
                                        <Typography
                                            key={i}
                                            paragraph
                                            className={classes.paragraphDialog}
                                        >
                                            <a
                                                className={classes.linkDialog}
                                                href={`tel:${phone?.telefonoNumero}`}
                                            >
                                                {formatRawPhoneNumber(phone?.telefonoNumero?.trim())}
                                            </a>
                                            <br />
                                        </Typography>
                                    ))
                                    :
                                    <Typography className={classes.paragraphDialogTelephoneExternal}>
                                        NO HAY TELEFONO
                                    </Typography>
                                }
                                <Typography className={classes.titleDialogContent}>
                                    DIRECCION:
                                </Typography>
                                {completeProfile?.prestador?.direccion.map((locationValue, key) => (
                                    <Typography
                                        key={key}
                                        paragraph
                                        className={classes.paragraphDialog}
                                    >
                                        {locationValue?.domicilio} | {locationValue?.localidad} | {locationValue?.barrio}
                                        <br />
                                    </Typography>
                                ))}
                                <Typography className={classes.titleDialogContent}>
                                    CORREO:
                                </Typography>
                                {
                                    !completeProfile?.prestador?.mail.length > 0 &&
                                    (
                                        <Typography
                                        paragraph
                                        className={classes.paragraphDialog}>
                                            NO HAY CORREO
                                        <br />
                                    </Typography>
                                    )
                                }
                                {completeProfile?.prestador?.mail.map((mailValue, index) => (
                                    <Typography
                                        key={index}
                                        paragraph
                                        className={classes.paragraphDialog}
                                    >
                                        <a className={classes.linkDialog} href={`mailto:${mailValue?.mailDireccion}`}>
                                            {mailValue?.mailDireccion}
                                        </a>
                                        <br />
                                    </Typography>
                                ))}
                            </>
                        }
                        observation={
                            <>
                                <Typography className={classes.titleDialogContent}>
                                    OBSERVACIONES:
                                </Typography>
                                {
                                    !completeProfile?.prestador?.datoAdicional.length > 0 &&
                                    (
                                        <Typography
                                        paragraph
                                        className={classes.paragraphDialog}>
                                            NO HAY OBSERVACIONES
                                        <br />
                                    </Typography>
                                    )
                                }
                                {completeProfile?.prestador?.datoAdicional.map((observations, y) => (
                                    <>
                                        {observations?.titulo === "OBSERVACIONES" && (
                                            <Typography
                                                key={y}
                                                paragraph
                                                className={classes.paragraphDialog}
                                            >
                                                {observations?.detalle}
                                                <br />
                                            </Typography>
                                        )}
                                    </>
                                ))}
                            </>
                        }
                        specialties={
                            <>
                                <Typography className={classes.titleDialogContent}>
                                    ESPECIALIDADES:
                                </Typography>
                                {completeProfile?.prestador?.especialidad.map((especialidadValue, z) => (
                                    <>
                                        <Typography key={z} className={classes.paragraphDialog}>
                                            {especialidadValue?.especialidadDescripcion}
                                        </Typography>
                                    </>
                                ))}
                            </>
                        }
                        open={open}
                        onClose={setOpen}
                    />)
                :
                <NotFound wsItem={completeProfile?.prestador} fullItem={completeProfile} />
            )
            }
        </>
    );
};

export default MedicalRecordContainer;